exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action_icon[data-v-979b5788] {\n  color: #5A4587 !important;\n}\n.action_icon[data-v-979b5788]:hover {\n  color: #9b89c3 !important;\n}\n", ""]);

// exports
